
import course from './entities/course';
import user from './entities/user';
import company from './entities/company';
import registration_event from './entities/registration_event';
import database from './entities/database';
import faq from './entities/faq';
import feedback from './entities/feedback';
import ideas_bank from './entities/ideas_bank';
import prize_shop from './entities/prize_shop';
import events from './entities/events';
import notifications from './entities/notification';
import favorite from './entities/favorite';
import rating from './entities/rating';
import live_news from './entities/live_news';
import activity from './entities/activity';
import learning from './entities/learning';
import main_page from './entities/main_page';
import app from './entities/app';
import certificate from './entities/certificate';
import studyPlan from './entities/study_plan';
import tests from './entities/tests';

const api = {
  course,
  user,
  company,
  database,
  faq,
  feedback,
  registration_event,
  ideas_bank,
  prize_shop,
  events,
  notifications,
  favorite,
  rating,
  live_news,
  activity,
  learning,
  main_page,
  app,
  certificate,
  studyPlan,
  tests,
};

export {api as default};
